var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-list',{attrs:{"dense":""}},_vm._l((_vm.innerMenu),function(item,i){return _c(item.is,{key:i,tag:"component",attrs:{"item":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }